meedy.controller('meedy.popupAvailabilityCreateController', ['$scope', '$state', '$mdDialog', 'resource', 'currentUserOriginSystem', 'meedy.availabilityRuleModel', 'applicationModel', '$cookies', 'meedy.userModel',
    function ($scope, $state, $mdDialog, resource, currentUserOriginSystem, availabilityRuleModel, applicationModel, $cookies, userModel) {

        function setData() {
            $scope.showAvailableTermType = currentUserOriginSystem !== Enum.ORIGIN_SYSTEM.MEEDY_PROTECT || (currentUserOriginSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT && userModel.currentUser.fromPanelAbc);
            console.log($scope.showAvailableTermType);

            $scope.availability = new AvailabilityRuleMeedyVO();
            if(!$scope.showAvailableTermType) {
                $scope.availability = new AvailabilityRuleOnlineMeedyVO();
            }
            $scope.availability.resource = resource;
            $scope.availability.dayDefinitions = [];
            $scope.color = { color: resource.color };


            $scope.now = new Date();

            $scope.monday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.MONDAY',
                dayType : Enum.MEEDY.DAY_TYPE.MONDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#monStart'
            };
            $scope.tuesday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.TUESDAY',
                dayType : Enum.MEEDY.DAY_TYPE.TUESDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#tuesdayStart'
            };
            $scope.wednesday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.WEDNESDAY',
                dayType : Enum.MEEDY.DAY_TYPE.WEDNESDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#wednesdayStart'
            };
            $scope.thursday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.THURSDAY',
                dayType : Enum.MEEDY.DAY_TYPE.THURSDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#thursdayStart'
            };
            $scope.friday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.FRIDAY',
                dayType : Enum.MEEDY.DAY_TYPE.FRIDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#fridayStart'
            };
            $scope.saturday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.SATURDAY',
                dayType : Enum.MEEDY.DAY_TYPE.SATURDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#saturdayStart'
            };
            $scope.sunday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.SUNDAY',
                dayType : Enum.MEEDY.DAY_TYPE.SUNDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#sundayStart'
            };

            if(!$scope.showAvailableTermType) {
                $scope.monday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.tuesday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.wednesday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.thursday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.friday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.saturday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
                $scope.sunday.emptyDayDefinition = new AvailabilityRuleDayOnlineDefinitionMeedyVO;
            }

            $scope.days = {
                monday: $scope.monday,
                tuesday: $scope.tuesday,
                wednesday: $scope.wednesday,
                thursday: $scope.thursday,
                friday: $scope.friday,
                saturday: $scope.saturday,
                sunday: $scope.sunday
            };
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.CREATE_AVAILABILITY_RULE.SUCCESS, function(event, data) {
                $mdDialog.hide();
                if($cookies.get('first_data_filled_' + userModel.currentUser.id) != 'true') {
                    if(currentUserOriginSystem) {
                        $cookies.put('first_data_filled_' + userModel.currentUser.id, 'true');
                        var configPopup = {
                            templateUrl: 'meedy/application/view/app/popup/popup-correct-filled-availability.html',
                            controller: 'meedy.popupFillDataController',
                            locals: {
                                $scope: $scope,
                                $mdDialog: $mdDialog
                            }
                        };
                        $mdDialog.show(configPopup).then(function () {
                            $state.go(Constant.STATE.APP.MEEDY.CALENDAR.DAILY_PLAN);
                        });
                    }
                }
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.CHECK_COLLISIONS.SUCCESS, function(event, list) {
                if(list && list.length > 0) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-collisions-popup.html',
                        controller: 'meedy.popupAvailabilityCollisionsController',
                        resolve: {
                            terms: function() {
                                return list;
                            },
                            message: function() {
                                return 'T.MEEDY.MODULE.AVAILABILITY.SAVE_AVAILABILITY_CONFIRMATION_MESSAGE';
                            }
                        }
                    }).then(function() {
                        availabilityRuleModel.createAvailabilityRule($scope.availability);
                    }, function(error){

                    })
                } else {
                    availabilityRuleModel.createAvailabilityRule($scope.availability);
                }
            });

        }

        function setActions() {
            $scope.addAvailability = function(day) {
                if(day.emptyDayDefinition.startTime && day.emptyDayDefinition.endTime) {
                    var dayDefinition = new AvailabilityRuleDayDefinitionMeedyVO();
                    dayDefinition.startTime = new Date(day.emptyDayDefinition.startTime);
                    dayDefinition.endTime = new Date(day.emptyDayDefinition.endTime);
                    dayDefinition.day= day.dayType;

                    day.emptyDayDefinition = new AvailabilityRuleDayDefinitionMeedyVO();

                    day.dayDefinitions.push(dayDefinition);

                    $('#' + $(day.focus + ' input')[0].id).focus();
                }
            };

            $scope.selectIcon = function(variable) {
                return !variable;
            };

            $scope.emptyDbClick = function() {
                return false;
            };

            $scope.removeAvailability = function(availability, day) {
                var dayDefinitions = day.dayDefinitions;


                day.dayDefinitions = _.remove(dayDefinitions, function(dayDefinition) {
                    return !(availability.startTime == dayDefinition.startTime && availability.endTime == dayDefinition.endTime);
                });
            };

            $scope.save = function () {
                $scope.forms.availability.$setSubmitted();
                if($scope.forms.availability.$valid) {

                    $scope.availability.dayDefinitions = _.union($scope.monday.dayDefinitions,
                        $scope.tuesday.dayDefinitions, $scope.wednesday.dayDefinitions, $scope.thursday.dayDefinitions,
                        $scope.friday.dayDefinitions, $scope.saturday.dayDefinitions, $scope.sunday.dayDefinitions);

                    setTimeout(function() {
                        availabilityRuleModel.checkCollisions($scope.availability);
                    }, 2000);

                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
